import ApiClient from "../ApiClient";
import { getRequestSubdomain } from "../utils/tenant";

export const TEAM_MEMBER_USER_TYPE = {
  ADMIN: 2,
  DEVELOPER: 4,
};

export function roleToUserType(role) {
  return role === "Admin" ? TEAM_MEMBER_USER_TYPE.ADMIN : TEAM_MEMBER_USER_TYPE.DEVELOPER;
}

export function userTypeToRole(userType) {
  const type = Number(userType);
  if (type === TEAM_MEMBER_USER_TYPE.ADMIN) return "Admin";
  return "Developer";
}

export function mapApiMemberToUi(item) {
  if (!item) return null;
  return {
    id: item.id,
    firstName: item.firstName || "",
    lastName: item.lastName || "",
    email: item.email || "",
    whatsAppNo: item.whatsAppNo || item.whatsappNo || "",
    role: userTypeToRole(item.userType),
    userType: item.userType,
    status: item.status === true ? "Active" : "Inactive",
    dateAdded: item.addedOn || item.dateAdded || "",
  };
}

const TeamMemberService = {
  async fetchTeamMembersList({
    companyId,
    pageNumber = 1,
    pageSize = 50,
    search = "",
    status,
  } = {}) {
    if (!companyId) {
      throw new Error("Company ID is required to fetch team members.");
    }

    try {
      const params = { PageNumber: pageNumber, PageSize: pageSize };
      if (search.trim()) params.Search = search.trim();
      if (status !== undefined && status !== null && status !== "") {
        params.Status = status;
      }

      const resp = await ApiClient.get(
        `/TeamMember/team-members-list/${companyId}`,
        { params }
      );
      return resp;
    } catch (error) {
      console.error("Error fetching team members:", error.response?.data || error.message);
      throw error;
    }
  },

  async addTeamMember(payload) {
    try {
      const resp = await ApiClient.post("/TeamMember/add-team-member", payload);
      return resp;
    } catch (error) {
      console.error("Error adding team member:", error.response?.data || error.message);
      throw error;
    }
  },

  async updateTeamMember(payload) {
    try {
      const resp = await ApiClient.patch("/TeamMember/update-team-member", payload);
      return resp;
    } catch (error) {
      console.error("Error updating team member:", error.response?.data || error.message);
      throw error;
    }
  },

  async deleteTeamMember(memberId) {
    try {
      const resp = await ApiClient.delete("/TeamMember/delete-team-member", {
        params: { memberId },
      });
      return resp;
    } catch (error) {
      console.error("Error deleting team member:", error.response?.data || error.message);
      throw error;
    }
  },

  async changeTeamMemberPassword(payload) {
    try {
      const resp = await ApiClient.patch("/Auth/change-team-member-password", {
        email: payload.email,
        password: payload.password,
        accountId: payload.accountId,
        currentPassword: payload.currentPassword,
        subdomain: payload.subdomain ?? getRequestSubdomain(),
      });
      return resp;
    } catch (error) {
      console.error(
        "Error changing team member password:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default TeamMemberService;
